import { useQuery } from '@tanstack/react-query'
import { fetchInvoicingLanguages, IGeneralConstantOption } from '../constants'
import { useBusinessContext } from '@root/context'

export const useInvoicingLanguages = () => {
  const { slug } = useBusinessContext()

  return useQuery<IGeneralConstantOption[]>({
    queryKey: [slug, 'invoicing_languages'],
    queryFn: () => fetchInvoicingLanguages({ slug }),
    staleTime: 1000 * 60 * 60,
    refetchOnMount: false,
    refetchIntervalInBackground: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    enabled: !!slug
  })
}
